import React from 'react'
import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'

const TermsWrapper = styled.div`
  padding: 12px;
  color: #022136;
  font-size: 90%;
  max-height: 350px;
  overflow-y: scroll;
  li {
    font-size: 90%;
    margin-left: 2em;
  }
  h6 {
    color: ${COLORS.brightGreen};
    font-weight: 600;
  }
  h6, p {
    width: 90%;
    margin: 10px auto;
  }
  p {
    display: flex;
    span {
      margin-left: 8px;
    }
  }
  ${SIZES.mobile} {
    min-height: 350px;
    max-height: inherit;
    p {
      font-size: 80%;
      span {
        margin-left: 6px;
      }
    }
    li {
      font-size: 80%;
      margin-left: 0;
    }
  }
`

function TermsTab() {
  return (
    <TermsWrapper>
      <h6>Terms and Conditions</h6>
      <p>1. <span>Points are earned through the visiting Auditorium Hall (At-least 1 Q&A) for the session and visiting the virtual booth at the Exhibition Hall.</span></p>
      <p>2. <span>The highest points need must be exceeding 160 points in order to win the Lucky Draw.</span></p>
      <p>3. <span>A total of 10 points can be earned from each booth. A coin icon will appear once the task has been completed.</span></p>
      <p>4. <span>Only 2 lucky prizes to be won per participant for each day.</span></p>
      <ul>
        <li>2 x Lucky Prize Winners of RM500 / per person</li>
        <li>2 Lucky Prizes x RM500 Winner of Global DFI Forum Malaysia 2021!</li>
      </ul>
      <p>5. <span>The Calculation for the winner based on a points system and engagement during the forum.</span></p>
    </TermsWrapper>
  )
}

export { TermsTab }
